import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import {
  TranslateModule,
  TranslateLoader,
  TranslateService,
} from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild({
      useDefaultLang: true,
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: false,
      extend: true,
    }),
  ],
  exports: [CommonModule, TranslateModule],
})
export class SharedModule {
  constructor(private translate: TranslateService) {
    let currentLanguage = sessionStorage.getItem("currentLang");
    translate.addLangs(["en", "es"]);
    translate.setDefaultLang("es");
    if (currentLanguage != null) {
      translate.use(currentLanguage);
    } else {
      translate.use("es");
      sessionStorage.setItem("currentLang", "es");
    }
  }

  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [TranslateService],
    };
  }
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
